import React from 'react';
import { useParams } from 'react-router-dom';

import LoadingIndicator from 'components/loading-indicator';
import CustomPage from 'containers/custom-page';
import { AVAILABLE_TEMPLATES } from 'constants/custom-page';
import usePremiumServiceGuard from 'hooks/premium-service-guard';
import { PREMIUM_SERVICE } from 'constants/premium-services';

const EventDetailsPage = () => {
  usePremiumServiceGuard(PREMIUM_SERVICE.events);

  const { eventSlug } = useParams();

  return (
    <React.Suspense fallback={<LoadingIndicator />}>
      <CustomPage customPageId={eventSlug} params={{ template: AVAILABLE_TEMPLATES.event }} />
    </React.Suspense>
  );
};

export default EventDetailsPage;
